// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3ybAl","fadeInAnimation":"Header_fadeInAnimation__jQ9Mo","title":"Header_title__1sBYO","buttonHolder":"Header_buttonHolder__3JXF_"};